export const media = {
  bookingPassenger: "/media/booking/passenger-v1.webp",
  bookingLuggage: "/media/booking/luggage-v1.webp",
  bookingBride: "/media/booking/people/bride-v1.webp",
  bookingGroom: "/media/booking/people/groom-v1.webp",
  bookingFormalGuestA: "/media/booking/people/formal-guest-a-v1.webp",
  bookingFormalGuestB: "/media/booking/people/formal-guest-b-v1.webp",
  bookingFormalGuestC: "/media/booking/people/formal-guest-c-v1.webp",
  bookingGraduate: "/media/booking/people/graduate-v1.webp",
  bookingMilestoneHonoree: "/media/booking/people/milestone-honoree-v1.webp",
  bookingCelebrationGuest: "/media/booking/people/celebration-guest-v1.webp",
  bookingBusinessTraveler: "/media/booking/people/business-traveler-v1.webp",
  bookingLeisureTraveler: "/media/booking/people/leisure-traveler-v1.webp",
  brandLogo: "/media/brand/danaro-logo-920d4022.svg",
  brandAnimation: "/media/brand/danaro-crest-467fdf60.mjs",
  flagUs: "/media/icons/flag-us-421ff0a9.svg",
  menu: "/media/icons/menu-d197c318.svg",
  accountIcon: "/media/icons/account-965e46c7.svg",
  arrowRightIcon: "/media/icons/arrow-right-5e269a39.svg",
  arrowLeftIcon: "/media/icons/arrow-left-e30d1f22.svg",
  arrowDownIcon: "/media/icons/arrow-down-0d625144.svg",
  arrowUpIcon: "/media/icons/arrow-up-b11bd4b3.svg",
  pause: "/media/icons/pause-06a5335c.svg",
  play: "/media/icons/play-81722050.svg",
  search: "/media/icons/search-85481174.svg",
  heroPosterDesktop: "/media/hero/poster-desktop-b9337fe0.webp",
  heroPosterMobile: "/media/hero/poster-mobile-b9337fe0.webp",
  heroVideoDesktop: "/media/video/hero/b9337fe0/desktop/master.m3u8",
  heroVideoMobile: "/media/video/hero/b9337fe0/mobile/master.m3u8",
  fleetMenuStretchLimo10: "/media/fleet/menu/10pp-stretch-limo-bb538e0c.png",
  fleetMenuEscaladeStretch:
    "/media/fleet/menu/18pp-escalade-suv-stretch.png",
  fleetMenuInfinitiStretch:
    "/media/fleet/menu/18pp-infinity-suv-stretch.png",
  fleetMenuRollsRoycePhantom:
    "/media/fleet/menu/rolls-royce-phantom.png",
  fleetMenuRollsRoycePrinzing:
    "/media/fleet/menu/rolls-royce-prinzing-516ea857.png",
  fleetMenuBentleyMulsanne: "/media/fleet/menu/bentley-mulsanne.png",
  fleetMenuCoachBus: "/media/fleet/menu/coach-bus.png",
  fleetMenuSetraCoach: "/media/fleet/menu/setra-topclass-white-right-v1.png",
  fleetMenuCadillacEscalade: "/media/fleet/menu/cadillac-escalade.png",
  fleetMenuMercedesSClass: "/media/fleet/menu/mercedes-s-class.png",
  fleetMenuPartyBus: "/media/fleet/menu/party-bus.png",
  fleetMenuPinkInfiniti: "/media/fleet/menu/pink-infiniti.png",
  fleetMenuLuxurySedan: "/media/fleet/menu/luxury-sedan.png",
  fleetMenuTowncar: "/media/fleet/menu/towncar.png",
  fleetMenuMercedesSprinter: "/media/fleet/menu/mercedes-sprinter.png",
  fleetMenuLuxurySuv: "/media/fleet/menu/luxury-suv.png",
  featuredWeddings: "/media/home/featured/weddings.webp",
  featuredFleet: "/media/home/featured/fleet.webp",
  featuredReviews: "/media/home/featured/reviews.webp",
  fleetWeddingCarsDesktop: "/media/home/fleet/wedding-cars-desktop.webp",
  fleetWeddingCarsMobile: "/media/home/fleet/wedding-cars-mobile.webp",
  fleetStretchLimousinesDesktop:
    "/media/home/fleet/stretch-limousines-desktop-f8e7b570.webp",
  fleetStretchLimousinesMobile:
    "/media/home/fleet/stretch-limousines-mobile-f8e7b570.webp",
  fleetLuxurySedansDesktop: "/media/home/fleet/luxury-sedans-desktop.webp",
  fleetLuxurySedansMobile: "/media/home/fleet/luxury-sedans-mobile.webp",
  fleetLuxurySuvsDesktop: "/media/home/fleet/luxury-suvs-desktop.webp",
  fleetLuxurySuvsMobile: "/media/home/fleet/luxury-suvs-mobile.webp",
  fleetSprintersDesktop: "/media/home/fleet/sprinters-desktop.webp",
  fleetSprintersMobile: "/media/home/fleet/sprinters-mobile.webp",
  fleetPartyCoachBusesDesktop:
    "/media/home/fleet/party-coach-buses-desktop.webp",
  fleetPartyCoachBusesMobile:
    "/media/home/fleet/party-coach-buses-mobile.webp",
  fleetWeddingCarsVideoDesktop:
    "/media/video/fleet/wedding-cars/danaro-824f9d71/desktop/master.m3u8",
  fleetWeddingCarsVideoMobile:
    "/media/video/fleet/wedding-cars/danaro-824f9d71/mobile/master.m3u8",
  fleetStretchLimousinesVideoDesktop:
    "/media/video/fleet/stretch-limousines/danaro-fb6988a8/desktop/master.m3u8",
  fleetStretchLimousinesVideoMobile:
    "/media/video/fleet/stretch-limousines/danaro-fb6988a8/mobile/master.m3u8",
  fleetLuxurySedansVideoDesktop:
    "/media/video/fleet/luxury-sedans/desktop/master.m3u8",
  fleetLuxurySedansVideoMobile:
    "/media/video/fleet/luxury-sedans/mobile/master.m3u8",
  fleetLuxurySuvsVideoDesktop:
    "/media/video/fleet/luxury-suvs/desktop/master.m3u8",
  fleetLuxurySuvsVideoMobile:
    "/media/video/fleet/luxury-suvs/mobile/master.m3u8",
  fleetSprintersVideoDesktop:
    "/media/video/fleet/sprinters/desktop/master.m3u8",
  fleetSprintersVideoMobile:
    "/media/video/fleet/sprinters/mobile/master.m3u8",
  fleetPartyCoachBusesVideoDesktop:
    "/media/video/fleet/party-coach-buses/danaro-5359bab3/desktop/master.m3u8",
  fleetPartyCoachBusesVideoMobile:
    "/media/video/fleet/party-coach-buses/danaro-5359bab3/mobile/master.m3u8",
  fleetWeddingCarsSignature: "/media/signatures/wedding-cars-5b5b6db3.svg",
  fleetStretchLimousinesSignature:
    "/media/signatures/stretch-limousines-b68b9965.svg",
  fleetLuxurySedansSignature: "/media/signatures/luxury-sedans-f9cfe3c4.svg",
  fleetLuxurySuvsSignature: "/media/signatures/luxury-suvs-35e9f236.svg",
  fleetSprintersSignature: "/media/signatures/sprinters-fadd1476.svg",
  fleetPartyCoachBusesSignature: "/media/signatures/party-coach-buses-984783f7.svg",
  planningImage: "/media/home/planning/danaro-arrival-e322a9fc.webp",
  fleetFinderImage: "/media/home/finder/fleet.webp",
  servicesBanner: "/media/home/services/banner.webp",
  serviceWeddings: "/media/home/services/weddings.webp",
  serviceProms: "/media/home/services/proms.webp",
  serviceParties: "/media/home/services/parties.webp",
  discoverGroups: "/media/home/discover/groups.webp",
  discoverExecutive: "/media/home/discover/executive.webp",
  discoverAbout: "/media/home/discover/about.webp",
  contactPhoneIcon: "/media/icons/contact-phone-79c13895.svg",
  contactEmailIcon: "/media/icons/contact-email-f0fb5d64.svg",
  contactDirectionsIcon: "/media/icons/contact-directions-fe79f895.svg",
  callDanaroBadge: "/media/badges/call-danaro-08a9cb26.svg",
  planRideBadge: "/media/badges/plan-your-ride-da3fe263.svg",
  bbbRatingBadge: "/BBB-Rating.svg",
  googleLogo: "/google-g.svg",
  socialFacebookIcon: "/media/icons/social-facebook-a7e13bb1.svg",
  socialInstagramIcon: "/media/icons/social-instagram-082c6403.svg",
  socialYoutubeIcon: "/media/icons/social-youtube-ad324d7c.svg",
} as const

export type MediaKey = keyof typeof media

export function mediaUrl(key: MediaKey) {
  return media[key]
}
